// extracted by mini-css-extract-plugin
module.exports = {"link":"Nav_link__1CVGd","theme_switch_wrapper":"Nav_theme_switch_wrapper__1BxNr","switch":"Nav_switch__SyzJt","toggle_check":"Nav_toggle_check__3rN6D","slider":"Nav_slider__aLjzs"};